import { ApiNationality } from '../api-types/nationality.api';
import { Nationality } from '../app-types/nationality.app';
/**
 * Transforms an ApiNationality object to an app-specific Nationality object.
 * @param input ApiNationality
 * @description Transforms an ApiNationality object to an app-specific Nationality object.
 * @returns Nationality
 */
export const transformApiNationalityToAppNationality = (input: ApiNationality | undefined) => {
	const output: Nationality = {
		id: input?.id,
		nationality: input?.nationality,
		initials: input?.initials,
	};
	return output;
};

/**
 * Transforms an array of ApiNationality objects to an array of app-specific
 * Nationality objects.
 * @param input Array of ApiNationality objects
 * @description Transforms an array of ApiNationality objects to an array of app-specific Nationality objects.
 * @returns Array of app-specific Nationality objects
 */
export const transformApiNationalitiesToAppNationalities = (input: ApiNationality[]) => {
	const output: Nationality[] = input.map(transformApiNationalityToAppNationality);
	return output;
};

/**
 * Transforms an app-specific Nationality object to an ApiNationality object.
 * @param input Nationality
 * @returns ApiNationality
 */
export const transformAppNationalityToApiNationality = (input: Nationality | undefined) => {
	const output: ApiNationality = {
		id: input?.id,
		nationality: input?.nationality,
		initials: input?.initials,
	};
	return output;
};
